module.exports = __webpack_public_path__ + "img/18.40489384.png";